import { endOfDay, startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear } from 'date-fns';
import { translate } from '@/core/translations';
import { Formatter } from '@/core/utils/Formatter';
import { type DateRange } from '@/types';
import { MAX_SAFE_DATE, TimeFilterPresets } from '../TimeFilterControl.const';

const presetToRangeFns: Record<Exclude<TimeFilterPresets, 'CUSTOM_RANGE'>, (today: Date) => [Date, Date]> = {
  [TimeFilterPresets.CURRENT_DAY]: (today) => [startOfDay(today), endOfDay(today)],
  [TimeFilterPresets.CURRENT_WEEK]: (today) => [startOfWeek(today), today],
  [TimeFilterPresets.CURRENT_MONTH]: (today) => [startOfMonth(today), today],
  [TimeFilterPresets.CURRENT_QUARTER]: (today) => [startOfQuarter(today), today],
  [TimeFilterPresets.FUTURE]: (today) => [today, MAX_SAFE_DATE],
  [TimeFilterPresets.CURRENT_YEAR]: (today) => [startOfYear(today), today], // specified in requirements
};

export const timePresetToDateRange = (preset: TimeFilterPresets): DateRange | null => {
  if (preset === TimeFilterPresets.CUSTOM_RANGE) return null;

  const today = new Date();
  const rangeFn = presetToRangeFns[preset];

  if (!rangeFn) throw new Error(translate('incidents_page.time_control.invalid_time_preset'));

  const [fromDate, toDate] = rangeFn(today);

  return {
    from: Formatter.toFilterDateTime(fromDate),
    to: Formatter.toFilterDateTime(toDate),
  };
};
